export default "__VITE_ASSET__DcYbffD___"